<script>
    /*
    	DataTaxonomyEditor.svelte
    */

    import { onMount } from 'svelte';

    // the master Review object (store)
	// import { masterReview } from '../../common/master-objects.js';

    // TCARE components
    import TaxonomySelectPanel from './TaxonomySelectPanel.svelte';

    // SMUI components
    import Dialog, { Title, Content, Actions } from '@smui/dialog';
    import Button, { Label } from '@smui/button';

    const BG_PATH = 'img/tcare_symbol.png';

    
    export let isShowingEditor;
    export let onHideEditor;
    export let taxName;
    export let store;
  
    $: taxonomyObj = $store.taxonomies[taxName] || null;        // the JS object - not API data


    onMount(() => {
        // console.log('');
        // console.log('DataTaxonomyEditor onMount');
    })


</script>

<style>

    .popup-title-row {
        padding: 15px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: var(--tcare-aqua);
    }

    .popup-title-icon {
        width: 30px;
        height: 24px;
    }

    .popup-title-icon img {
        width: 100%;
        height: 100%;
    }

    .popup-title-name {
        margin-left: 10px;
        font-size: 1.5em;
        font-weight: normal;
        color: var(--tcare-primary);
    }

    .padded-content {
        padding: 15px;
    }

    :global(.data-tax-editor .mdc-dialog .mdc-dialog__surface) {
        width: 1000px;
        max-width: 1000px;
        border-radius: 18px;
    }

    :global(.data-tax-editor .select-panel) {
        width: 100%;
        /* height: 400px; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="data-tax-editor">
    <Dialog bind:open={isShowingEditor} scrimClickAction="" escapeKeyAction="">

        <div class="popup-title-row ai-center jc-start">
            <div class="popup-title-icon"><img src={BG_PATH} alt={'TCARE Symbol'}></div>
            <div class="popup-title-name">Edit Keywords: {taxonomyObj.name}</div>
        </div>

        <div class="padded-content">
            <div class="select-panel">
                <!-- contains Chips, AutoComplete and TreeViewer -->
                <TaxonomySelectPanel {taxName} {store} />
            </div>

            <div class="flex-row jc-end">
                <Button variant="raised" on:click={() => onHideEditor()} tabindex={1}>
                    <Label>Close</Label>
                </Button>
            </div>
        </div>
    </Dialog>
</div>
